import * as core from '../../../../../../../core'

import { query } from './subrecipient-details.query'

export const RESOURCE = {
  payload: {
    alias: 'sr:subrecipient-details',
    content: {
      segments: [
        {
          name: 'Info',
          root: {
            elements: [
              {
                height: 800,
                content: {
                  widget: {
                    widget: {
                      alias: 'sr.subrecipient-details.widgets.info',
                    },
                  },
                },
              },
            ],
          },
          alias: 'info',
        },
        {
          name: 'Institutional Risk Assessments',
          root: {
            elements: [
              {
                height: 800,
                content: {
                  widget: {
                    widget: {
                      alias:
                        'sr.subrecipient-details.widgets.institutional-risk-assessments-table',
                    },
                  },
                },
              },
            ],
          },
          alias: 'institutional-risk-assessments',
        },
      ],
      navigator: core.mosaic.Page.Segment.Navigator.Tabs,
    },
    description: 'Subrecipient Details',
    name: 'Subrecipient Details',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicPage>
